import { useUiFromSpecContext } from '../EditorContextProvider'
import { Tab } from '@headlessui/react'
import clsx from 'clsx'
import { useTranslation } from '../hooks/useTranslation'

export function TabPreviewForm({ allowpreview = true }: { allowpreview?: boolean }) {
  const { editor, setEditor } = useUiFromSpecContext()
  const { t } = useTranslation()

  const TabPreviewList = [
    {
      label: 'Form Definition',
      value: false,
    },
    {
      label: 'Form Preview',
      value: true,
    },
  ]

  if (!allowpreview) {
    return null
  }
  return (
    <Tab.Group
      selectedIndex={editor ? 0 : 1}
      onChange={(index) => {
        setEditor && setEditor(!index)
      }}
    >
      <Tab.List className="flex space-x-1 w-min rounded-lg bg-slate-100 p-1">
        {TabPreviewList.map((item) => (
          <Tab
            key={item.label}
            className={({ selected }) =>
              clsx(
                'rounded-lg py-2 px-3 w-max text-xs font-medium leading-5',
                'focus:ring-0 focus:outline-none',
                selected ? 'bg-white text-black shadow' : 'text-black'
              )
            }
          >
            {t(`tabPreviewForm.${item.label}`)}
          </Tab>
        ))}
      </Tab.List>
    </Tab.Group>
  )
}
